import { render } from "./DeleteIcon.vue?vue&type=template&id=5b915632"
const script = {}
script.render = render

export default script